import { useContext } from "react";
import { useSelector } from "react-redux";
import { Tag } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  tags: Tag[];
  retrieveProjectsTags(
    request: Boundaries["retrieveProjectsTags"]["request"],
  ): void;
}

function useRetrieveProjectsTags(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectsTagsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectsTagsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectsTagsRequestFailure,
    ),
    tags: useSelector(selector.getProjectsTags),
    retrieveProjectsTags: core.retrieveProjectsTags,
  };
}

export { useRetrieveProjectsTags };
